import "../../../../App.css";
import SearchForm from "./NtnSearchForm";
import NtnHeader from "../../../../common/components/NtnHeader";
import NtnResultForm from "./NtnResultForm";
import { Backdrop, Container, createTheme } from "@material-ui/core";
import { connect, Provider } from "react-redux";
import { convertHex, extractUrlParams } from "../../../../common/utils/Utils";
import _ from "lodash";
import { SnackbarProvider } from "notistack";
import Spinner from "../../../../common/components/SpinnerCustomized";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { ThemeProvider } from "@mui/styles";
import store from "../../../../common/state/Store";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";
import { NtnFooter } from "../../../../common/components/NtnFooter";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#232f66",
        },
        secondary: {
            main: "#ffffff",
        },
        accent1: {
            main: "#484848",
        },
        accent2: {
            main: "#7e7e7e",
        },
        accent3: {
            main: "#f3f3f3",
        },
        error: {
            main: "#F50909FF",
        },
        success: {
            main: "#07851CFF",
        },
    },
});

const buildBackDropLayer = (children) => {
    return (
        <Backdrop
            style={{
                flex: 1,
                zIndex: 200,
                color: "white",
                backgroundColor: convertHex("#232f66", 70),
            }}
            open={true}
        >
            {children}
        </Backdrop>
    );
};

function PortalApp(props) {
    const unauthorizedPort = _.pickBy(props.PortsReducer, isUnautorized);
    const unauthorizedShipment = _.pickBy(props.ShipmentReducer, isUnautorized);
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider maxSnack={3}>
                    {(!_.isEmpty(unauthorizedPort) || !_.isEmpty(unauthorizedShipment)) &&
                        buildBackDropLayer(
                            <Box>
                                <Typography
                                    variant="h5"
                                    component="h5"
                                    style={{
                                        textAlign: "center" + "",
                                    }}
                                >
                                    Votre session a expiré. Veuillez vous reconnecter au G.U
                                </Typography>
                            </Box>
                        )}
                    <div style={{ flex: 1 }}>
                        {props.loadingProps?.isLoading ? <Spinner /> : <></>}

                        <NtnHeader
                            theme={theme}
                            username={props.shipmentsByUser.data.username}
                        ></NtnHeader>

                        <Container
                            style={{
                                justifyContent: "center",
                                alignItems: "center",
                                width: "80%",
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid
                                    item
                                    xs={12}
                                    //md={9}
                                >
                                    <Paper style={{ height: "75", width: "200" }}>
                                        <Container
                                            style={{
                                                border: "2px solid #404f92",
                                                backgroundColor: theme.palette.accent3.main,
                                                padding: "20px",
                                                marginTop: "30px",
                                                marginBottom: "20px",
                                            }}
                                        >
                                            <Box style={{ marginBottom: "5px" }}>
                                                <Typography
                                                    sx={{
                                                        color: theme.palette.primary.main,
                                                        fontSize: "1.5rem",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Paramètres de recherche
                                                </Typography>
                                            </Box>
                                            <Box style={{ marginLeft: "20px", fontWeight: "bold" }}>
                                                <Typography style={{ fontWeight: "bold" }}>
                                                    <li>
                                                        Numéro de conteneur + Port + Numéro de réservation{" "}
                                                    </li>
                                                </Typography>
                                                <Typography style={{ fontWeight: "bold" }}>
                                                    <li>
                                                        {" "}
                                                        Numéro de conteneur + Port + Numéro de connaissement{" "}
                                                    </li>
                                                </Typography>
                                                <Typography style={{ fontWeight: "bold" }}>
                                                    <li>Numéro de conteneur + Port + ETA + ETD </li>
                                                </Typography>
                                            </Box>
                                        </Container>
                                    </Paper>
                                </Grid>
                                {/*<Grid item xs={12} md={3}>
                  <Paper style={{ height: "75", width: "50" }}>
                    <Container
                      style={{
                        border: "2px solid #404f92",
                        backgroundColor: theme.palette.accent3.main,
                        padding: "20px",
                        marginTop: "30px",
                        marginBottom: "20px",
                        height: "155px",
                      }}
                    >
                      <NtnOperateurSolde
                        solde={props.solde.data?.solde}
                      ></NtnOperateurSolde>
                    </Container>
                  </Paper>
                </Grid>*/}
                            </Grid>

                            {props.shipments.info && (
                                <Typography
                                    variant="h6"
                                    color="orange"
                                    style={{
                                        border: "1px solid orange",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#F8E1D2FF",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i className="fa fa-exclamation-triangle"></i>{" "}
                                    {props.shipments.info}
                                </Typography>
                            )}
                            {props.shipmentsRefresh.error?.status == 400 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>{" "}
                                    {props.shipmentsRefresh.error?.message}
                                </Typography>
                            )}
                            {props.shipments.error?.status == 400 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>{" "}
                                    {props.shipmentsRefresh.error?.message}
                                    {props.shipments.error?.message}
                                </Typography>
                            )}

                            {props.shipmentsRefresh.error?.status == 500 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>{" "}
                                    {props.shipmentsRefresh.error?.message}
                                </Typography>
                            )}
                            {props.shipments.error?.status == 500 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>{" "}
                                    {props.shipmentsRefresh.error?.message}
                                    {props.shipments.error?.message}
                                </Typography>
                            )}
                            {props.blockScreen && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i> Veuillez vous
                                    reconnecter au Guichet Unique
                                </Typography>
                            )}
                            <SearchForm
                                ports={props.portList.data}
                                params={extractUrlParams(window.location.href)}
                            ></SearchForm>

                            <NtnResultForm
                                theme={theme}
                                shipments={
                                    _.isEmpty(props.shipments.data)
                                        ? props.shipmentsByUser.data.list
                                        : props.shipments.data.list
                                }
                            ></NtnResultForm>
                        </Container>
                    </div>
                </SnackbarProvider>

                <div style={{ flex: 2 }}>
                    <NtnFooter theme={theme} />
                </div>
            </ThemeProvider>
        </Provider>
    );
}

function isUnautorized(value) {
    return value?.status === 401;
}
const mapStateToProps = (state) => {
    let loadingProps;
    let reducerHasLoading = _.pickBy(state, { isLoading: true });

    if (reducerHasLoading) {
        const target = _.keys(reducerHasLoading)[0];
        let nextProps = reducerHasLoading[target];
        if (target) {
            loadingProps = { ...nextProps };
        }
    }
    return {
        ...state,
        shipmentsByUser: state.ShipmentByUserReducer,
        shipments: state.ShipmentReducer,
        shipmentsRefresh: state.ShipmentRefreshReducer,
        portList: state.PortsReducer,
        solde: state.SoldeReducer,
        loadingProps: loadingProps,
    };
};

export default connect(mapStateToProps)(PortalApp);
